import { Form, Formik } from "formik";
import React from "react";
import { useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { SimpleModal } from "src/app/components";
import { SimpleFormControl } from "src/app/components/form/SimpleFormControl";
import Pacman from "src/app/components/layout/Pacman";
import { useFindIfUrlIsAlreadyBoosted, useMinimumCpmPerLang } from "src/app/hooks";
import { OrderTransport } from "src/app/transports/order";
import { IActionsModal } from "src/app/types/actionsModal";
import { TLangType } from "src/app/types/LangType";

const CampaignsModalContainer = (
    props: IActionsModal<{ lang: TLangType; id: number; cpm: number; maxCost: number; url: string }>
) => {
    const { handleClose = () => {}, entity, updateGridOnSave } = props;
    const [loading, setLoading] = useState(false);
    const { formatMessage } = useIntl();
    const { minimumCpm, loading: loadingMinimumCpm } = useMinimumCpmPerLang(entity.lang);
    const { keywords } = useFindIfUrlIsAlreadyBoosted(entity.url);

    const handleSubmit = async (_value: { cpm: number; maxCost: number }) => {
        setLoading(true);

        try {
            await OrderTransport.createCampaigns(entity.id, { ..._value });
            toast.success(formatMessage({ id: "common.notification.success" }));
            updateGridOnSave && updateGridOnSave({}, true);
            handleClose();
        } catch (error: any) {
            toast.error(formatMessage({ id: "common.notification.error" }));
        } finally {
            setLoading(false);
        }
    };

    return (
        <SimpleModal
            entityName={formatMessage({ id: "common.entity.areYouSure" })}
            handleClose={handleClose}
            loading={loading}
            formId="createCampaign"
            buttonConfirmationLabel={formatMessage({ id: "common.action.confirmation" })}
            showModal={true}
            modalProps={{ size: undefined }}
        >
            {loadingMinimumCpm ? (
                <Pacman />
            ) : (
                <Formik
                    initialValues={{
                        cpm: entity.cpm || minimumCpm || 0,
                        maxCost: entity.maxCost || 20,
                    }}
                    onSubmit={handleSubmit}
                >
                    {(formikProps) => (
                        <Form id="createCampaign">
                            <div className="d-flex gap-2">
                                <SimpleFormControl
                                    min={minimumCpm}
                                    label={formatMessage(
                                        { id: "common.field.cpm" },
                                        { minimumCpm }
                                    )}
                                    name="cpm"
                                    step={0.01}
                                    max={0.5}
                                    type="number"
                                />
                                <SimpleFormControl
                                    label={formatMessage({ id: "common.field.maxCost" })}
                                    name="maxCost"
                                    type="number"
                                    min={1}
                                    max={25}
                                    step={0.5}
                                />
                            </div>
                            <label className="form-label">Views : </label>{" "}
                            {Math.round(
                                (formikProps.values.maxCost / formikProps.values.cpm) * 1000
                            )}
                            {keywords?.length !== 0 && (
                                <>
                                    <br />
                                    <label className="form-label">
                                        {formatMessage({ id: "common.field.alreadyBoosted" })} :
                                    </label>
                                    <br />
                                    <ul>
                                        {keywords?.map((el, index) => (
                                            <li key={index}>{el}</li>
                                        ))}
                                    </ul>
                                </>
                            )}
                        </Form>
                    )}
                </Formik>
            )}
        </SimpleModal>
    );
};

export default CampaignsModalContainer;
